$(document).ready(function () {
  $('[data-toggle=slide]').click(function () {
    if ($('.sidebar-slide').css('background-color') == 'rgb(255, 255, 255)') {
	    $('.list-group-item').attr('tabindex', '-1');
    } else {
	    $('.list-group-item').attr('tabindex', '');
    }
    $('.row-slide').toggleClass('active');    
  });
$('.breadcrumbs-affix').affix({
  offset: {
    top: 1
  }
})
});